export enum MailFrequency {
  Never = 'Never',
  Asap = 'Asap',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly'
}
